import React, { useState } from "react";
import { Button } from "antd";
import {
  getCategoryTemplateExport,
  getUnitsTemplateExport,
  getProductTemplateExport,
} from "../network/network";
import { useTranslation } from "react-i18next";
import { handleApiError } from "../utils/errorHandler";

const DownloadImportTemplate = ({ type }) => {
  const [loadingBTN, setLoadingBTN] = useState(false);
  const PRODUCT = "product";
  const CATEGORY = "category";
  const UNIT = "unit";
  const { t } = useTranslation();

  const downloadTemplate = (request) => {
    setLoadingBTN(true);
    request()
      .catch((error) => handleApiError(error, t))
      .finally(() => {
        setLoadingBTN(false);
      });
  };

  const unitTemplateExport = () => downloadTemplate(getUnitsTemplateExport);
  const categoryTemplateExport = () =>
    downloadTemplate(getCategoryTemplateExport);
  const productTemplateExport = () =>
    downloadTemplate(getProductTemplateExport);

  return (
    <>
      {type === PRODUCT && (
        <Button
          type="primary"
          onClick={() => {
            productTemplateExport();
          }}
          loading={loadingBTN}
        >
          {t("download_template")}
        </Button>
      )}
      {type === CATEGORY && (
        <Button
          type="primary"
          onClick={() => {
            categoryTemplateExport();
          }}
          loading={loadingBTN}
        >
          {t("download_template")}
        </Button>
      )}
      {type === UNIT && (
        <Button
          type="primary"
          onClick={() => {
            unitTemplateExport();
          }}
          loading={loadingBTN}
        >
          {t("download_template")}
        </Button>
      )}
    </>
  );
};

export default DownloadImportTemplate;
